export default __webpack_public_path__ + "static/media/padilogo.b52fc868.png";